import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { AssistantConfigActions, AssistantConfigSelectors } from '@core/intelligence-data';

@Injectable({ providedIn: 'root' })
export class HrAssistantConfigDataService {
  private readonly store = inject(Store);
  private readonly configState = this.store.selectSignal(AssistantConfigSelectors.state);

  public readonly configData = this.store.selectSignal(AssistantConfigSelectors.data);

  public fetchConfig() {
    this.store.dispatch(AssistantConfigActions.fetch());
  }

  public fetchIfNotLoaded() {
    const { pending, loaded } = this.configState();
    if (pending || loaded) return;

    this.fetchConfig();
  }
}
